import React, { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import trackingIcon from "assets/tracking.png";
import accountantIcon from "assets/i2.png";
import announcementIcon from "assets/i3.png";
import contactIcon from "assets/i4.png";
import bg2 from "assets/bg2.jpg";

const Card = ({ title, icon, onClick }) => (
  <button
    onClick={onClick}
    className="w-full h-64 bg-white/90 border border-white/70 rounded-xl shadow-md flex flex-col items-center justify-center hover:shadow-lg transition hover:bg-white/100 hover:scale-[1.02] transform duration-200"
  >
    <div className="w-32 h-32 flex items-center justify-center mb-3">
      <img src={icon} alt={title} className="w-24 h-24 object-contain" />
    </div>
    <span className="text-[#133B6E] font-semibold text-xl">{title}</span>
  </button>
);

const Home = () => {
  const { isLoggedIn, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if not logged in AND we've finished loading auth state
    if (!loading && !isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate, loading]);

  // Show loading indicator while auth state is being determined
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#003F75]"></div>
          <p className="text-gray-500 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render anything if not logged in (will redirect)
  if (!isLoggedIn) return null;

  return (
    <div
      className="py-20 min-h-[calc(100vh)] relative"
      style={{
        backgroundImage: `url(${bg2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#133B6E]/20 backdrop-blur-[1px]"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-white mb-2 drop-shadow-md">
          Dijla Clearing & Forwarding
        </h1>
        <p className="text-white/90 text-lg mb-10 max-w-2xl">
          Your trusted partner for clearing and forwarding services
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card
            title="Tracking"
            icon={trackingIcon}
            onClick={() => navigate("/tracking")}
          />
          <Card title="Accountant" icon={accountantIcon} onClick={() => {}} />
          <Card
            title="Announcements"
            icon={announcementIcon}
            onClick={() => navigate("/announcements")}
          />
          <Card
            title="Contact us"
            icon={contactIcon}
            onClick={() => navigate("/contact")}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
